export default "__VITE_ASSET__BDK0MDO4__"